import { useQuery } from 'react-query';

import { Insight, getInsight } from '@utils/backend-api/insights';

export const INSIGHTS_KEY = 'insights';

export default function useInsight({ entitySource, entitySourceAttribute, limit = 10 }) {
  const { data: insight, isLoading: isLoadingInsight } = useQuery<Insight>(
    [INSIGHTS_KEY, entitySource, entitySourceAttribute, limit],
    async () => await getInsight(entitySource, entitySourceAttribute, limit)
  );
  return { insight, isLoadingInsight };
}
